export { default } from './VerifiedForm';
